<template>
    <v-dialog width="600px" v-model="showFaq">
        <template v-slot:activator="{ props }">
        <v-btn text  @click="showFaq=!showFaq"  class="mr-1" color="F15A24" style="text-transform:none;">
           
                <v-icon color="#F15A24">mdi-help-circle-outline</v-icon> Precisa de Ajuda?
            </v-btn>
        </template>
        <v-card>
            <v-toolbar
              color=""
              dark
            >
            <v-icon color="#F15A24" class="mr-3">mdi-help-circle-outline</v-icon>
            Perguntas frequentes de {{ this.$route.name }}</v-toolbar>
            <v-card-text>
                <v-expansion-panels class="mt-5">
                    <v-expansion-panel v-for="(p,i) in faq" :key="p.id">
                        <v-expansion-panel-header class='justify-start'>
                            <p class="mb-0">
                                <span style="font-weight:bold">{{ i +1 }}.</span> {{ p.pergunta }}
                            </p>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="px-1">
                            <div v-html="p.resposta">

                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="showFaq=!showFaq">
                Fechar
                </v-btn>
            </v-card-actions>
          </v-card>
    </v-dialog>
</template>
<script>
export default { 
    name:"DialogFaq",
    props: {},
    data() { 
        return { 
            showFaq: false,
            faq: []
        } 
    },
    watch:{ 
        "$route.name":{
            handler: function(newValue) { 
                this.reloadFaq(newValue)
            },
            deep:true
        }
    },
    mounted() { 
        this.reloadFaq(this.$route.name)
    },
    methods: { 
        async reloadFaq(page) { 
            const { data } = await this.$http.get(`items/faq/?filter[pagina][_eq]=${page}&filter[status][_eq]=published`);
                this.faq = data.data
        }
    }
}
</script>